export default __webpack_public_path__ + "static/media/sticker-os.6f430a92.png";